import { FC } from 'react';
import { useController, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Dropdown, DropdownOption, DropdownProps, } from '../../UI';
import { PersonFormValues } from '..';
import { RelationshipType } from './../../generated/graphql';

interface PersonRelationshipDropdownProps extends Pick<DropdownProps, 'dropdownMenuClassName' | 'className'> {
}

export const PersonRelationshipDropdown : FC<PersonRelationshipDropdownProps> = (dropdownProps) => {
  const { t: tForm } = useTranslation('form');
  const { t: tDisplay } = useTranslation('display');
  const { control, } = useFormContext<PersonFormValues>();
  const {
    field,
    fieldState: { error },
  } = useController<PersonFormValues, 'relationship'>({
    control,
    name: 'relationship',
    rules: { required: true },
  });

  return (
    <Dropdown
      {...field}
      {...dropdownProps}
      value={field.value}
      status={error ? 'errored' : 'normal'}
      onChange={(data) => field.onChange(data)}
      label={tForm('person-relationship-dropdown-label')}
      placeholder={tForm('general-required-placeholder')}
    >
      <DropdownOption 
      id={RelationshipType.HeadOfHousehold} 
      value={RelationshipType.HeadOfHousehold} 
      label={tDisplay('head-of-household')} />
      <DropdownOption
        id={RelationshipType.Partner}
        value={RelationshipType.Partner}
        label={tDisplay('partner')}
      />
      <DropdownOption
        id={RelationshipType.Wife}
        value={RelationshipType.Wife}
        label={tDisplay('wife')}
      />
      <DropdownOption
        id={RelationshipType.Husband}
        value={RelationshipType.Husband}
        label={tDisplay('husband')}
      />
      <DropdownOption
        id={RelationshipType.Son}
        value={RelationshipType.Son}
        label={tDisplay('son')}
      />
      <DropdownOption
        id={RelationshipType.Daughter}
        value={RelationshipType.Daughter}
        label={tDisplay('daughter')}
      />
      <DropdownOption
        id={RelationshipType.Child}
        value={RelationshipType.Child}
        label={tDisplay('child')}
      />
      <DropdownOption
        id={RelationshipType.Grandchild}
        value={RelationshipType.Grandchild}
        label={tDisplay('grandchild')}
      />
    </Dropdown>
);

};
